var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28279 0.981201C8.14908 0.981201 8.97989 1.32533 9.59245 1.93789C10.205 2.55046 10.5491 3.38127 10.5491 4.24756C10.5491 5.11385 10.205 5.94466 9.59245 6.55722C8.97989 7.16978 8.14908 7.51392 7.28279 7.51392C6.4165 7.51392 5.58569 7.16978 4.97313 6.55722C4.36057 5.94466 4.01643 5.11385 4.01643 4.24756C4.01643 3.38127 4.36057 2.55046 4.97313 1.93789C5.58569 1.32533 6.4165 0.981201 7.28279 0.981201ZM7.28279 9.14709C10.8921 9.14709 13.8155 10.6088 13.8155 12.4135V14.0466H0.750076V12.4135C0.750076 10.6088 3.67347 9.14709 7.28279 9.14709Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.328392df5ccaebc1f43bfdd7d6605756.svg";
export { ForwardRef as ReactComponent };